import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { fetchPage } from 'store/actions/page';

import Header from 'parts/Header';
import Footer from 'parts/Footer';
import Swiper from 'parts/Swiper';
import Categories from 'parts/Categories';

function ProductsPage(props) {
    const dispatch = useDispatch();
    const page = useSelector(state => state.page);

    useEffect(() => {
        // Set the page title and scroll position
        document.title = "Green Hill Resort | Produk Kami";
        window.scrollTo(0, 0);

        // Fetch page data if not already available
        if (!page.categories) {
            dispatch(fetchPage(`/categories`, 'categories'));
        }
    }, [dispatch, page]);

    // Show nothing until data is loaded
    if (!page.hasOwnProperty("categories")) return null;

    return (
        <>
            <Header {...props} />
            <Swiper />
            <Categories data={page.categories.data} />
            <Footer />
        </>
    );
}

export default ProductsPage;